import React from 'react';
import { DateTimeRangePicker } from '@leverege/ui-elements';
import { useValueChange } from '@leverege/ui-hooks';
import HistoryViewModel from "../models/HistoryViewModel.js";
import DataViewerCardModel from "../../dashboard/DataViewerCardModel.js";
import { jsx as _jsx } from "react/jsx-runtime";
export default {
  id: 'history.DateRange',
  layout: {
    sort: 'z'
  },
  matches: {
    client: 'HistoryView',
    use: 'filterBar'
  },
  handles: context => {
    const {
      clientProps
    } = context;
    const {
      dataViewerCardModel
    } = clientProps;
    const needsDate = dataViewerCardModel && DataViewerCardModel.getNeedsDate(dataViewerCardModel);
    return !needsDate;
  },
  customComponent: DateRangeComponent
};
function getTimeValue(range) {
  if (typeof range === 'string') {
    return range;
  }
  const ret = {
    ...range
  };
  if (ret.start != null && !(ret.start instanceof Date)) {
    ret.start = new Date(ret.start);
  }
  if (ret.end != null && !(ret.end instanceof Date)) {
    ret.end = new Date(ret.end);
  }
  return ret;
}
function DateRangeComponent({
  context
}) {
  const {
    clientProps
  } = context;
  const {
    settings: model,
    settingsData: eventData,
    onSettingsChange: onChange
  } = clientProps;
  const range = HistoryViewModel.getRange(model);
  const timeValue = getTimeValue(range);
  const onChangeModel = useValueChange(HistoryViewModel, {
    ...clientProps,
    value: model,
    eventData,
    onChange
  });
  return /*#__PURE__*/_jsx(DateTimeRangePicker, {
    variant: "history",
    value: timeValue,
    eventData: "setRange",
    onChange: onChangeModel
  });
}